import { useEffect } from "react";
import CenteredPopup from "../CenteredPopup/CenteredPopup";
import FirebaseKey from "../FirebaseKey/FirebaseKey";
import FirebaseService from "../../core/services/firebase.service";

const REDIRECT_URL = "https://pepsi.kazan-kazan.com/close-webview";
const REDIRECT_DELAY_MS = 3000;

interface TransactionErrorPopupProps {
  isOpen: boolean;
}

const TransactionErrorPopup = ({ isOpen }: TransactionErrorPopupProps) => {
  useEffect(() => {
    if (!isOpen) return;

    const timeoutId = window.setTimeout(() => {
      window.location.href = REDIRECT_URL;
    }, REDIRECT_DELAY_MS);

    return () => window.clearTimeout(timeoutId);
  }, [isOpen]);

  return (
    <CenteredPopup
      isOpen={isOpen}
      onClose={() => {}}
      closeOnBackdrop={false}
    >
      <div className="flex flex-col p-6">
        <h2 className="text-base font-semibold text-black mb-2">
          <FirebaseKey firebaseKey={FirebaseService.error_title} />
        </h2>
        <p className="text-sm text-black/80 mb-4">
          <FirebaseKey firebaseKey={FirebaseService.error_desc} />
        </p>
        <p className="text-sm text-black/60">
          <FirebaseKey firebaseKey={FirebaseService.error_redirect_note} />
        </p>
      </div>
    </CenteredPopup>
  );
};

export default TransactionErrorPopup;
